"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToaster = void 0;
const react_1 = require("react");
function useToaster({ delay, maxToasts = 4, }) {
    const [toasts, setToasts] = react_1.useState([]);
    const addToast = react_1.useCallback((message) => {
        const id = Date.now() + Math.random();
        const dismiss = () => setToasts(toasts => toasts.filter(t => t.id !== id));
        setToasts(toasts => [...toasts, { id, message, dismiss, delay }]);
    }, [setToasts, delay]);
    const firstToasts = react_1.useMemo(() => toasts.slice(0, maxToasts), [maxToasts, toasts]);
    const memoDeps = [...firstToasts, ...Array(maxToasts - firstToasts.length).fill(undefined)];
    const toastsToReturn = react_1.useMemo(() => [...firstToasts], memoDeps);
    return react_1.useMemo(() => {
        return [toastsToReturn, addToast];
    }, [toastsToReturn, addToast]);
}
exports.useToaster = useToaster;
//# sourceMappingURL=useToaster.js.map